import { render, staticRenderFns } from "./unSuspendEmployee.vue?vue&type=template&id=157b216b&scoped=true"
import script from "./unSuspendEmployee.vue?vue&type=script&lang=js"
export * from "./unSuspendEmployee.vue?vue&type=script&lang=js"
import style0 from "./unSuspendEmployee.vue?vue&type=style&index=0&id=157b216b&prod&scoped=true&lang=css"
import style1 from "./unSuspendEmployee.vue?vue&type=style&index=1&id=157b216b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b216b",
  null
  
)

export default component.exports